import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import apiClient from "../../../axios";
import SuccessProcess from '../SuccessProcess';
import LoginNotification from "../LoginNotification";
import ErrorNotification from '../ErrorNotification';

const StatusWhatsApp = ({ detail, message, isVisible, onClose, origen }) => {

    const [successVisible, setSuccessVisible] = useState(false);
    const [isInfoVisible, setIsInfoVisible] = useState(false);
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const [message2, setMessage2] = useState('');

    const handleCloseSuccess = () => {
        setSuccessVisible(false);
        onClose();
    };

    const handleConfirm = async () => {
        try {
            if (origen === 'whatsApp') {
                const payloadUpdate = {
                    apiKey: detail.makiApiKey,
                    userId: detail.makiUserId,
                    flagActive: !detail.flagActive
                };
                await apiClient.patch(`/whatsappDetails/status/${detail.id}`, payloadUpdate);
                const status = !detail.flagActive;
                const message = status
                    ? "Plan de WhatsApp Activado Correctamente"
                    : "Plan de WhatsApp Inactivado Correctamente";
                setMessage2(message);
                setSuccessVisible(true);

            }else if (origen === 'userE'){
                const payloadUpdate = {
                    password: detail.password,
                    flagActive: !detail.flagActive
                };
                await apiClient.patch(`/gema/user/${detail.gemaId}`, payloadUpdate);
                const status = !detail.flagActive;
                const message = status
                    ? "Usuario Activado Correctamente"
                    : "Usuario Inactivado Correctamente";
                setMessage2(message);
                setSuccessVisible(true);

            }

        } catch (error) {
            setMessage2('Ocurrió un error al actualizar el Estado.');
            if (error.response.data.error === "Unauthorized") {
                setIsInfoVisible(true);
            }
            setIsErrorVisible(true);
        }
    };


    return (
        isVisible && (
            <div className="info-notification-info-overlay">
                <div className="info-notification-info">
                    <div className="icon-container-noti-info">
                        <FontAwesomeIcon icon={faCircleInfo} className={"icon-noti4"} />
                    </div>
                    <div className="message-container-info">
                        <h4>Información</h4>
                        <p style={{ whiteSpace: 'pre-line' }}>{message}</p>
                    </div>
                    <div className="button-container-info">
                        <button className="cancel-btn-info" onClick={onClose}>
                            Cancelar
                        </button>
                        <button className="ok-btn-info" onClick={handleConfirm}>
                            OK
                        </button>
                    </div>
                    <SuccessProcess
                        message={message2}
                        isVisible={successVisible}
                        onClose={handleCloseSuccess}
                        //pageNavigate = {('/WhatsAppDetailsList', { state: { contract: detail.numCont } })}
                        redirectOnOk={false}
                        whatsApp={false}
                    />
                    <ErrorNotification
                        message="Ups! Ocurrio un Problema"
                        isVisible={isErrorVisible}
                        onClose={() => setIsErrorVisible(false)}
                    />
                    <LoginNotification
                        message="Vuele a iniciar sesión"
                        isVisible={isInfoVisible}
                        onClose={() => setIsInfoVisible(false)}
                    />
                </div>
            </div>
        )
    );
};

export default StatusWhatsApp;
